import React, {useState, useEffect} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {toast} from 'react-toastify';
import {X} from 'react-bootstrap-icons';
import {deleteInvoiceById} from '../../../../../../../../crud/management_api/invoices';
import MiniLoadingSpinner from '../../../../../../../../components/Spinners/MiniLoadingSpinner';

interface DeleteInvoiceProps {
  invoiceId: number;
  show: boolean;
  onClose: () => void;
  onDeleted?: (invoiceId: number) => void; // Nuevo callback opcional
}

const DeleteInvoice: React.FC<DeleteInvoiceProps> = ({invoiceId, show, onClose, onDeleted}) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteInvoice = () => {
    setLoading(true);
    deleteInvoiceById(invoiceId)
      .then(() => {
        toast.success('Factura eliminada correctamente');
        if (onDeleted) onDeleted(invoiceId); // Notificar al padre
        onClose();
      })
      .catch((error) => {
        console.error('Error al eliminar la factura:', error);
        toast.error('Error al eliminar la factura');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Eliminar Factura</Modal.Title>
        </div>
        <Button variant="none" onClick={onClose} disabled={loading}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <MiniLoadingSpinner/>
        ) : (
          <p>¿Estás seguro de que deseas eliminar esta factura?</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="none" className='form-button-cancel' onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="none" className='form-button-create' onClick={handleDeleteInvoice} disabled={loading}>
          Eliminar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};


export default DeleteInvoice;